import { useState } from 'react';
import { useIntakeChangeRequest } from './use-intake-change-request';

type ClientValue = string | number | boolean | null;

export function useIntakeChangeRequestReview(clientId: string) {
  const requestState = useIntakeChangeRequest(clientId);
  const [changed, setChanged] = useState(false);
  const [decision, setDecision] = useState<'approved' | 'rejected' | null>(null);
  const [values, setValues] = useState<Record<string, ClientValue>>({});
  const [rejectOpen, setRejectOpen] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  const request = requestState.data?.request;

  const markChangedAfterRefetch = async () => {
    const refreshed = await requestState.refetch();
    setChanged(
      refreshed.data?.request?.id !== request?.id || refreshed.data?.request?.status !== 'pending',
    );
  };

  const approveRequest = async () => {
    if (!request) return;
    try {
      await requestState.approve({ requestId: request.id, values });
      setDecision('approved');
    } catch {
      await markChangedAfterRefetch();
    }
  };

  const rejectRequest = async () => {
    if (!request) return;
    try {
      await requestState.reject({ requestId: request.id, reason: rejectionReason.trim() });
      setRejectOpen(false);
      setDecision('rejected');
    } catch {
      await markChangedAfterRefetch();
    }
  };

  return {
    ...requestState,
    request,
    values,
    changed,
    decision,
    changeValue: (questionRef: string, value: ClientValue) =>
      setValues(current => ({ ...current, [questionRef]: value })),
    approveRequest,
    rejectRequest,
    rejectOpen,
    setRejectOpen,
    rejectionReason,
    setRejectionReason,
  };
}
